import api from "../../api/sphinxAPI";

/** =========== VISUALIZER =========== **/
export const createNewKanban = async function(creatorId) {
  if (!creatorId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newKanban`,
      data: { creatorId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getKanban = async function(kanbanId) {
  if (!kanbanId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/kanban`,
      params: { kanbanId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getAllKanbans = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/allKanbans`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const createNewColumn = async function(kanbanId, columnIndex, creatorId, scopeEnabled) {
  if (!kanbanId || (!columnIndex && columnIndex !== 0) || !creatorId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newColumn`,
      data: { kanbanId, columnIndex, creatorId, scopeEnabled },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const createNewCard = async function(kanbanId, cardIndex, columnId, creatorId, scopeEnabled) {
  if (!kanbanId || (!cardIndex && cardIndex !== 0) || !columnId || !creatorId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newCard`,
      data: { kanbanId, cardIndex, columnId, creatorId, scopeEnabled },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getKanbanColumnsAndCards = async function(kanbanId) {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/kanbanColumnsAndCards`,
      params: { kanbanId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateColumnTitle = async function(columnId, newTitle) {
  if (!columnId || (!newTitle && newTitle !== "")) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedColumnTitle`,
      data: { columnId, newTitle },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateKanbanTitle = async function(kanbanId, newTitle) {
  if (!kanbanId || (!newTitle && newTitle !== "")) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedKanbanTitle`,
      data: { kanbanId, newTitle },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateCardTitle = async function(cardId, newTitle) {
  if (!cardId || (!newTitle && newTitle !== "")) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedCardTitle`,
      data: { cardId, newTitle },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateCardDescription = async function(cardId, newDescription) {
  if (!cardId || (!newDescription && newDescription !== "")) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedCardDescription`,
      data: { cardId, newDescription },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateColumnIndexes = async function(kanbanId, columnIndexesData) {
  if (!kanbanId || !columnIndexesData) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedColumnIndexes`,
      data: { kanbanId, columnIndexesData },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateCardLocations = async function(kanbanId, cardLocationsData) {
  if (!kanbanId || !cardLocationsData) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updatedCardLocations`,
      data: { kanbanId, cardLocationsData },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const deleteKanban = async function(kanbanId) {
  if (!kanbanId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteKanban`,
      data: { kanbanId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const deleteCard = async function(cardId) {
  if (!cardId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteCard`,
      data: { cardId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const deleteSelectedColumn = async function(kanbanId, columnId) {
  if (!kanbanId || !columnId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteSelectedColumn`,
      data: { kanbanId, columnId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

const KanbanRequests = {
  createNewKanban,
  getAllKanbans,
  getKanban,
  createNewColumn,
  createNewCard,
  getKanbanColumnsAndCards,
  updateColumnTitle,
  updateKanbanTitle,
  updateCardTitle,
  updateCardDescription,
  updateColumnIndexes,
  updateCardLocations,
  deleteKanban,
  deleteCard,
  deleteSelectedColumn,
};

export default KanbanRequests;
